import { createLucideIcon } from "lucide-react-native";
import { ComponentProps } from "react";
import { Path } from "react-native-svg";

const MicrosoftIconBase = createLucideIcon("MicrosoftIcon", []);

const MicrosoftIcon = (props: ComponentProps<typeof MicrosoftIconBase>) => {
  return (
    <MicrosoftIconBase {...props}>
      <Path d="M0 0h11.4045v11.4045H0z" fill="#f25022" />
      <Path d="M12.5955 0H24v11.4045H12.5955z" fill="#7fba00" />
      <Path d="M0 12.5955h11.4045V24H0z" fill="#00a4ef" />
      <Path d="M12.5955 12.5955H24V24H12.5955z" fill="#ffb900" />
    </MicrosoftIconBase>
  );
};

export default MicrosoftIcon;
